<template>
  <div>
    <h5 class="margin-bottom-xs">
      {{ photos.length }} customer image{{ photos.length > 1 ? 's' : '' }}
    </h5>
    <Carousel
      :list="mappedPhotos"
      item-class="carousel-image"
      :number-of-items="{ large: photosToShowOnDesktopCount, medium: 4.5, small: 2.31 }"
      :gutter="{ large: 24, medium: 8, small: 8 }"
    >
      <template #item="{ data, index }">
        <img
          :src="data.url"
          :alt="data.caption"
          draggable="false"
          @click="onSelectPhoto(index)"
        >
      </template>
    </Carousel>
  </div>
  <FullReviewModal
    :photos="mappedPhotos"
    :reviews="reviewsPhotos"
    :selected-index="clickedPhotoIndex"
    :is-loading="isLoading"
  />
</template>

<script setup>
import Carousel from '@atomic-ui/carousel';
import {
  computed, ref,
} from 'vue';
import { useReviewsPhotos } from '@composables/reviews/useReviewsPhotos';
import FullReviewModal from '@components/reviews/FullReviewModal';
import { useModal } from '@composables/utils/useModal';

const props = defineProps({
  photos: {
    /** @type import('vue').PropType<ReviewPhotosObject[]> */
    type: Array,
    required: true,
    validator: (x) => x.length,
  },
  isOnTwoLines: {
    type: Boolean,
    required: true,
  },
});

const { open } = useModal();
const photosToShowOnDesktopCount = computed(() => (props.isOnTwoLines ? 6 : 3));

const { fetchReviewsWithPhotos, reviewsPhotos, isLoading } = useReviewsPhotos();
const clickedPhotoIndex = ref(0);

/**
 *
 * @param {String} photoUrl
 */
function getRelatedReview(photoUrl) {
  const reviewIndex = reviewsPhotos.value?.findIndex((review) => review.photos.some((photo) => photo.sizes.normal.url === photoUrl));

  return {
    reviewId: reviewsPhotos.value?.[reviewIndex]?.reviewId, reviewIndex,
  };
}

const mappedPhotos = computed(() => props.photos?.map((photo) => {
  // find review related to photo
  const { reviewIndex, reviewId } = getRelatedReview(photo.url);

  return {
    ...photo,
    reviewIndex,
    reviewId,
  };
}));

// const selectedPhoto = computed(() => mappedPhotos.value?.[clickedPhotoIndex.value ?? 0]);

/**
 *
 * @param {number} index
 */
function onSelectPhoto(index) {
  fetchReviewsWithPhotos();

  clickedPhotoIndex.value = index;

  open('full-review-modal');
}
</script>

<style lang="scss" scoped>
.carousel-image {
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
    cursor: pointer;
  }
}
</style>
